import { render, staticRenderFns } from "./LiveChatCTAV2Dialog.vue?vue&type=template&id=f491cda8&scoped=true&"
import script from "./LiveChatCTAV2Dialog.vue?vue&type=script&lang=js&"
export * from "./LiveChatCTAV2Dialog.vue?vue&type=script&lang=js&"
import style0 from "./LiveChatCTAV2Dialog.vue?vue&type=style&index=0&id=f491cda8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f491cda8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VSelect,VSwitch,VTextField})
